var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames},[_c('div',{directives:[{name:"rellax",rawName:"v-rellax",value:(_vm.rellaxOptions),expression:"rellaxOptions"}],staticClass:"BaseForeground__Bunch",style:(_vm.backgroundImage)})])
}
var staticRenderFns = []

export { render, staticRenderFns }